import { ApiUrlHelper } from '../../common/apiUrlHelper';
import { AfterViewInit, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { CommonService } from '../../services/common/common.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CollageModel } from 'src/app/models/collageModel';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SharedService } from '../../services/shared.service';
import { CollegeConstant } from 'src/app/constants/label-constants';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CollegeAddEditComponent } from './college-add-edit/college-add-edit.component';
import { CollegeViewComponent } from './college-view/college-view.component';
import { DeleteDialogboxComponent } from '../delete-dialogbox/delete-dialogbox.component';
import { StatusDialogboxComponent } from '../status-dialogbox/status-dialogbox.component';
import { CommonConstant, NoRecordFound } from 'src/app/constants/common-constant';
declare var $: any;
@Component({
  selector: 'app-collage-list',
  templateUrl: './college-list.component.html',
  styleUrls: ['./college-list.component.css']
})
export class CollegeListComponent implements OnInit, AfterViewInit {
  collageForm: FormGroup = this.formBuilder.group({});
  CollageList: any = [];
  closeResult = '';
  enterSearch: string = '';
  searchClose: boolean = false;
  availableStock: number = 0;
  SortColumn: any = '';
  sortDirection: any = '';
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  showData: boolean = false;
  CommonConstant: any = [];
  NoRecordFound: any = [];
  CollegeConstant: any = [];
  pageSizeOptions: number[] = [5, 10, 25, 100];
  displayedColumns: string[] = ['rowNumber', 'collegeLogo', 'collegeName', 'state', 'city', 'mobileNo', 'isActive', 'Action'];
  dataSource: MatTableDataSource<CollageModel> = new MatTableDataSource();
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  collegeStatusObj: any = {};
  collegeDeleteObj: any = {};
  @HostListener('window:beforeunload', ['$event'])
  public canDeactivate(event: BeforeUnloadEvent): void {
    if (this.collageForm.dirty) {
      event.preventDefault();
      event.returnValue = false;
    }
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  constructor(
    private formBuilder: FormBuilder,
    public commonService: CommonService,
    private apiUrl: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    private sharedService: SharedService,
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.CommonConstant = CommonConstant;
    this.NoRecordFound = NoRecordFound;
    this.CollegeConstant = CollegeConstant;
    this.getCollageList();
    this.sharedService.setData('College');
  }

  getCollageList() {
    this.showData = false;
    const objData = {
      PageNumber: this.currentPage + 1,
      PageSize: this.pageSize,
      StrSearch: this.enterSearch,
      SortColumn: this.SortColumn,
      SortOrder: this.sortDirection
    }
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.college.GetCollegeList;
    this.commonService.doPost(apiUrl, objData).pipe().subscribe({
      next: async (response) => {
        this.spinner.hide();
        if (response.success) {
          this.showData = true;
          let TotalRecords = 0;
          this.CollageList = response.data
          this.dataSource.data = this.CollageList;
          if (this.CollageList.length > 0) {
            TotalRecords = this.CollageList[0].totalRecords;
            this.totalRows = TotalRecords;
          }
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = TotalRecords;
          });
        }
      },
      error: (error) => {
        this.spinner.hide();
      }
    });
  }

  pageChanged(event: { pageSize: number; pageIndex: number; }) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getCollageList();
  }

  SortChange(event: { direction: string; active: any; }) {
    this.sortDirection = event.direction == '' ? 'asc' : event.direction;
    this.SortColumn = event.active;
    this.getCollageList();
  }

  search(event) {
    if (event.target.value == '') {
      this.enterSearch = '';
      this.currentPage =0;
      this.getCollageList();
      this.searchClose = false;
    }
    else {
      this.searchClose = true;
    }
    if (event.key === "Enter" && event.target.value != '') {
      this.currentPage =0;
      this.enterSearch = event.target.value;
      this.getCollageList();
      this.searchClose = true;
    }
  }

  cancelSearch(): void {
    this.enterSearch = '';
    this.getCollageList();
    this.searchClose = false;
  }

  sanitizeInput(event: any) {
    const inputElement: HTMLInputElement = event.target;
    const sanitizedValue: string = inputElement.value.replace(/\D/g, '');
    inputElement.value = sanitizedValue;
  }

  AddEditcollege(collegeId: number) {
    const modalRef = this.modalService.open(CollegeAddEditComponent, { centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.collegeId = collegeId;
    modalRef.result.then((result) => {
      if (result === 'save') {
        this.getCollageList();
      }
    }).catch((error) => {
    });
  }

  CollegeListDetail(collegeId) {
    const modalRef = this.modalService.open(CollegeViewComponent, { centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.collegeId = collegeId;
    modalRef.result.then((result) => {
    }).catch((error) => {
    });
  }

  Deletepopup(collegeId: number, collegename: string) {
    const modalRef = this.modalService.open(DeleteDialogboxComponent, { centered: true, backdrop: 'static', keyboard: false });
    this.collegeDeleteObj = {
      collegeId: collegeId,
      collegename: collegename,
      element: 'college'
    }
    modalRef.componentInstance.collegeDeleteObj = this.collegeDeleteObj;
    modalRef.result.then((result) => {
      if (result === 'delete') {
        this.getCollageList();
      }
    }).catch((error) => {
    });
  }

  onStatus(collegeId: number, collegename: string, active: boolean) {
    const modalRef = this.modalService.open(StatusDialogboxComponent, { centered: true, backdrop: 'static', keyboard: false });
    this.collegeStatusObj = {
      collegeId: collegeId,
      collegename: collegename,
      activecollege: active
    }
    modalRef.componentInstance.collegeStatusObj = this.collegeStatusObj;
    modalRef.result.then((result) => {
      if (result === 'status') {
        this.CollageList.forEach((element: { collegeId: number; isActive: boolean; }) => {
          if (element.collegeId == collegeId) {
            element.isActive = active ? false : true
          }
        });
      }
    }).catch((error) => {
    });
  }

  handleImageError(event: any) {
    event.target.src = '../../../assets/img/default_college.png';
    event.onerror = null;
  }
}